const defaultRender = (value) => (value  ? value : '--');

const columns = [
  {
    title: "Image",
    dataIndex: "bannerUrl",
    key: "bannerUrl",
    reder: defaultRender,    
    width: 100
  },
  {
    title: "Banner Caption",
    dataIndex: "bannerCaption",
    sorter: true,
    width: 100
  },
  {
    title: "Banner Type",
    dataIndex: "bannerType",
    width: 100
  },
  {
    title: "Banner View Type",
    dataIndex: "bannerViewType",
    sorter: true,
    width: 100
  },
  {
    title: "Created Date",
    dataIndex: "createdDate",
    sorter: true,
    width: 100
  },
  {
    title: "Status",
    dataIndex: "status",
    width: 100
  },
  {
    title: "Actions",
    dataIndex: "actions",
    width: 100
  },
];

export default columns;
